import { jwtDecode } from "jwt-decode";
import { getStoredAuthToken, isAuthTokenValid } from "../../utils/authSession";

const ALLOWED_CLIENT_IDS = new Set([11, 12, 13, 87, 2, 56, 176, 5, 173, 14, 102, 172]);

export const canAccessSuporte = () => {
  try {
    const storedToken = getStoredAuthToken();
    if (!isAuthTokenValid(storedToken)) return false;

    const token = storedToken.startsWith("Bearer ") ? storedToken.slice(7) : storedToken;
    const claims = jwtDecode(token);
    const clientId =
      claims?.id_clienteAipim ??
      claims?.id_clienteaipim ??
      claims?.idClienteAipim ??
      claims?.id_cliente ??
      claims?.idCliente ??
      claims?.cliente_id;

    if (typeof clientId !== "number" && typeof clientId !== "string") return false;
    return ALLOWED_CLIENT_IDS.has(Number(clientId));
  } catch {
    return false;
  }
};
